import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_CORGI_GQL_STATS_CONFIG = defineFcm('corgi_gql_stats_config')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: {
					type: 'boolean',
				},
				persist: {
					type: 'boolean',
				},
				trackedClients: {
					type: 'array',
					shape: {
						type: 'string',
					},
				},
				minClientVersions: {
					type: 'record',
					shape: {
						type: 'string',
					},
				},
			},
		}),
	)
	.withDefault({
		enabled: false,
		persist: false,
		trackedClients: [],
		minClientVersions: {},
	})
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'GQL stats',
		description: `Configuration for GraphQL stats collection in Corgi Middle End.

		"enabled" - whether to enable GraphQL stats collection.
		"persist" - whether to persist the collected stats to Valkey. If false, stats will only be kept in memory.
		"allowedClients" - list of client names allowed to have their GraphQL field usage tracked.
		"minClientVersions" - minimum client versions (semver) required for tracking field usage.

		⚠️ Only global group is supported.`,
		import: false,
		template: {
			enabled: false,
			persist: false,
			trackedClients: [
				'corgi-front-end-server',
				'corgi-front-end-browser',
				'change-ios',
				'change-android',
				'change-public-api',
				'optimizely',
			],
			minClientVersions: {
				'corgi-front-end-server': '0.0.0',
				'corgi-front-end-browser': '0.0.0',
				'change-ios': '0.0.0',
				'change-android': '0.0.0',
			},
		},
	});
